import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../../config';
import { useAuth } from '../../auth';
import SavedViews from './SavedViews';
import AiLauncher from './AiLauncher';
import BulkProgress from '../BulkProgress';

// Le pagine senza voce qui non mostrano niente a sinistra (nessun titolo di ripiego).
const PAGE_TITLES = {
  '/': 'Dashboard',
  '/dashboard-evo': 'Dashboard EVO',
  '/import': 'Import',
  '/numeri': 'Numeri',
  '/export': 'Export',
  '/verifiche': 'Verifiche',
  '/impostazioni': 'Impostazioni',
};

export default function HeaderBar() {
  const location = useLocation();
  const { can } = useAuth();
  const [now, setNow] = useState(new Date());
  const [health, setHealth] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const load = () => {
      axios.get(`${API}/settings/health-status`).then(r => setHealth(r.data)).catch(() => {});
    };
    load();
    const interval = setInterval(load, 15000);
    return () => clearInterval(interval);
  }, []);

  const title = PAGE_TITLES[location.pathname] || '';
  const statusColor = health?.status === 'operativo' ? 'var(--color-non-tim)'
    : health?.status === 'standby' ? 'var(--color-tim)'
    : 'var(--color-warning)';
  const statusText = health?.status === 'operativo' ? 'Sistema operativo'
    : health?.status === 'standby' ? 'Sistema fermo'
    : 'Sistema...';

  return (
    <div className="header-bar">
      <div className="header-bar-left">
        {title && <span className="header-bar-title">{title}</span>}
      </div>
      {location.pathname === '/' && (can('dash_analisi') || can('dash_export')) && (
        <div className="header-bar-center"><SavedViews /></div>
      )}
      {/* A destra: progresso dei lavori (spazio fisso per sei anelli), AI, ora e pallino.
          Niente qui cambia larghezza: i lavori che compaiono non spostano gli altri. */}
      <div className="header-bar-right">
        <BulkProgress />
        <AiLauncher />
        <span className="header-bar-time">{now.toLocaleTimeString('it-IT')}</span>
        <span className="header-bar-status" role="img" title={statusText} aria-label={statusText}>
          <span className="header-bar-dot" style={{
            background: statusColor,
            boxShadow: `0 0 0 3px color-mix(in srgb, ${statusColor} 22%, transparent)`,
          }} />
        </span>
      </div>
    </div>
  );
}
